import { render, staticRenderFns } from "./EditBusinessMemberPrescriptionRxItems.vue?vue&type=template&id=70259917"
import script from "./EditBusinessMemberPrescriptionRxItems.vue?vue&type=script&lang=js"
export * from "./EditBusinessMemberPrescriptionRxItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports